/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_7_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn in the order your workbook needs`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_7_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按工作簿的实际需要学习`)
};

/**
* | output |
* | --- |
* | "Learn in the order your workbook needs" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_7_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_7_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_7_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_7_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_7_title as "gc.search_guides.what_is_gridcraft.sections.7.title" }